/**
 * The default data for the Update Member Password Form component.
 */
export const defaultUpdateMemberPasswordFormData = {
    password: '',
    currentPassword: '',
    captcha: undefined
};
